import { motion } from 'framer-motion';
import styled, { css, keyframes } from 'styled-components';

import { Button, ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

import { PUBLISH_BAR_HEIGHT, PUBLISH_BAR_HEIGHT_MOBILE } from '../styles';

interface PublishBarWrapperProps {
    $newNavigation: boolean;
}

export const PublishBarWrapper = styled(motion.div)<PublishBarWrapperProps>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
    height: ${PUBLISH_BAR_HEIGHT_MOBILE}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px;
    background-color: #2a2637;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding: 0 40px;
        height: ${PUBLISH_BAR_HEIGHT}px;
    }
`;

export const ActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 16px;
    }
`;

export const ActionsRight = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    gap: 5px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 10px;
    }
`;

export const WalletZone = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
`;

export const RoundedLeft = styled.div`
    background-color: #2a2637;
    position: absolute;
    left: 0;
    top: 100%;
    pointer-events: none;

    mask: radial-gradient(16px at 100% 100%, #0000 98%, #000);
    width: 16px;
    height: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        mask: radial-gradient(29px at 100% 100%, #0000 98%, #000);
        width: 29px;
        height: 29px;
    }
`;

export const RoundedRight = styled.div`
    background-color: #2a2637;
    position: absolute;
    right: 0;
    top: 100%;
    pointer-events: none;

    mask: radial-gradient(16px at 0 100%, #0000 98%, #000);
    width: 16px;
    height: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        mask: radial-gradient(29px at 0 100%, #0000 98%, #000);
        width: 29px;
        height: 29px;
    }
`;

const breatheAnimation = keyframes`
    0% { opacity: 0.5; }
    50% { opacity: 0.2; }
    100% { opacity: 0.5; }
`;

export const PublishButton = styled(Button)<{ $isSending?: boolean }>`
    ${({ $isSending }) =>
        $isSending &&
        css`
            animation: ${breatheAnimation} 2s infinite;
            cursor: pointer;
            pointer-events: none;
        `};

    &:disabled {
        cursor: pointer;
        pointer-events: none;
        opacity: 0.8;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        min-width: 147px;
    }
`;

export const CancelButton = styled(Button)`
    transition: background-color 200ms ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.15);
    }
`;

export const IconButton = styled(ButtonIcon)`
    &&& {
        background: rgba(255, 255, 255, 0.1);
        transition: background-color 200ms ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.15);
        }
    }
`;
